module.exports = __webpack_public_path__ + "img/icon-alipay.49016f64.png";